/* eslint-disable consistent-return */
import fetch from 'isomorphic-unfetch';
import config from '../../config';

export const FETCH_TOP_PTS = 'PTS_RANKING:FETCH';
export const FETCH_TOP_PTS_SUCCESS = 'PTS_RANKING:FETCH_SUCCESS';
export const FETCH_TOP_PTS_FAILURE = 'PTS_RANKING:FETCH_FAILURE';

const { apiHost } = config;

export const fetchPtsRankings = (gender, top = 10, skip = 0) => async (
    dispatch,
) => {
    dispatch({ type: FETCH_TOP_PTS });
    try {
        const res = await fetch(
            `${apiHost}/pts/player/top?gender=${gender}&top=${top}&skip=${skip}`,
        );
        const data = await res.json();

        if (data.error) {
            dispatch({ type: FETCH_TOP_PTS_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_PTS_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_PTS_FAILURE });
    }
};
